module.exports = __webpack_public_path__ + "static/stat-a7414570d6fda1935f9718eb867aca6f.svg";